import script from "./SignUpPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpPayment.vue?vue&type=script&setup=true&lang=js"

import "./SignUpPayment.vue?vue&type=style&index=0&id=6dcf5bcc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dcf5bcc"]])

export default __exports__